import ReactDOM from 'react-dom'
import { useMemo } from 'react'

function getOrInsertPortal(idPortal) {
  let portalContainer = document.getElementById(idPortal)
  if (!portalContainer) {
    portalContainer = document.createElement('div')
    portalContainer.setAttribute('id', idPortal)
  }

  // Only move to end if not already at end (Ensure latest modal is on top)
  const isLastChild = document.body.lastElementChild === portalContainer
  if (!isLastChild) {
    document.body.appendChild(portalContainer)
  }

  // Always move to end of body (ensures latest modal is on top)
  document.body.appendChild(portalContainer)

  return portalContainer
}

function ReactPortal({ id, children }) {
  const portalContainer = useMemo(() => getOrInsertPortal(id), [id])
  return ReactDOM.createPortal(children, portalContainer)
}

export default ReactPortal
